<div class="flex flex-col h-full overflow-hidden" *transloco="let t">
	<!-- Header (sticky) -->
	<div class="flex items-center px-4 py-3 border-b border-black/10 flex-shrink-0">
		<mat-icon class="text-black/40 mr-3 flex-shrink-0">search</mat-icon>
		<input
			class="flex-1 border-0 outline-none text-base bg-transparent placeholder:text-black/40"
			type="text"
			placeholder="{{ t('realestates.searchPlaceholder') }}"
			(input)="onSearchInput($event)" />
		<button mat-icon-button mat-dialog-close class="flex-shrink-0 ml-2">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<!-- Body (scrollable) -->
	<div class="flex-1 overflow-y-auto py-2">
		<!-- Placeholder vor der Suche -->
		@if (!hasSearched()) {
			<div class="flex flex-col items-center justify-center py-12 px-6 text-black/40 gap-3">
				<mat-icon class="!text-5xl !w-12 !h-12">search</mat-icon>
				<span class="text-sm text-center">{{ t('realestates.searchPlaceholder') }}</span>
			</div>
		}

		<!-- Spinner während der Suche -->
		@if (hasSearched() && !allCategoriesLoaded()) {
			<div class="flex items-center justify-center py-12 px-6">
				<mat-spinner diameter="40"></mat-spinner>
			</div>
		}

		<!-- Ergebnisse (erst wenn alles geladen) -->
		@if (hasSearched() && allCategoriesLoaded()) {
			@if (!hasAnyResults()) {
				<div class="flex flex-col items-center justify-center py-12 px-6 text-black/40 gap-3">
					<mat-icon class="!text-5xl !w-12 !h-12">search_off</mat-icon>
					<span class="text-sm text-center">Keine Ergebnisse gefunden</span>
				</div>
			} @else {
				@for (category of categories; track category.key) {
					@if (category.items().length > 0) {
						<div>
							<div
								class="px-4 pt-3 pb-1 text-[13px] font-semibold tracking-[0.5px] text-[color:var(--color-primary)]"
								style="font-variant: small-caps">
								{{ category.label }}
							</div>

							@for (item of getDisplayedItems(category); track item.id) {
								<div class="flex items-center px-4 py-2 cursor-pointer gap-3 transition-colors hover:bg-black/[0.04]" (click)="item.onClick()">
									@if (item.iconUrl) {
										<img [src]="item.iconUrl" [matTooltip]="item.iconTooltip" alt="" width="24" height="24" class="flex-shrink-0 rounded" />
									}
									<div class="flex-1 min-w-0 flex flex-col gap-0.5">
										<div class="text-sm leading-tight">
											<span class="font-bold">{{ item.primary }}</span>
											@if (item.meta) {
												<span class="text-gray-500">{{ item.meta }}</span>
											}
										</div>
										@if (item.secondary) {
											<span class="text-xs text-black/50 truncate">{{ item.secondary }}</span>
										}
									</div>
									@if (item.tertiary) {
										<span class="flex-shrink-0 text-xs text-black/50 text-right max-w-[160px] truncate">{{ item.tertiary }}</span>
									}
									<mat-icon class="flex-shrink-0 text-black/25 !text-xl !w-5 !h-5">chevron_right</mat-icon>
								</div>
							}

							@if (hasMoreItems(category)) {
								<button
									class="block mx-4 my-1 px-3 py-1.5 w-[calc(100%-2rem)] border-0 rounded bg-black/[0.03] text-primary text-xs font-medium text-left cursor-pointer transition-colors hover:bg-black/[0.07]"
									(click)="expandCategory(category)">
									Weitere anzeigen ({{ category.totalCount() - 3 }})
								</button>
							}
						</div>
					}
				}
			}
		}
	</div>
</div>
